import { CreateWorkspaceDialog } from 'components'
import { useUiStore } from 'store'
import { AdminSidebar } from './admin-sidebar'
import { ProductSidebar } from './product-sidebar'

/**
 * The desktop rail. Two of them, one shell.
 *
 * The product rail is the canonical DS `Sidebar` (DEV-2392 / DS PR #108); the
 * admin rail is the hand-rolled shell it replaced, kept for the admin context
 * whose menu the DS `pages` API cannot express. Mobile has no sidebar at all —
 * this container is `hidden md:flex`.
 */
export const Sidebar = () => {
	const context = useUiStore((state) => state.context)

	return (
		<>
			<CreateWorkspaceDialog />
			<div
				className="app-sidebar hidden md:flex md:flex-col md:fixed md:bottom-0 bg-table-band relative z-[31]"
				style={{ top: 'var(--cg-announcement-height, 0px)' }}
			>
				{context === 'admin' ? <AdminSidebar /> : <ProductSidebar />}
			</div>
		</>
	)
}
